import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { MapitPasswordTextField } from "src/components/common";
import PersonIcon from "@mui/icons-material/Person";

export default function ConfirmPasswordDialogAdmin({
  open,
  onClose,
  title,
  onConfirm,
  onPasswordChange,
  loading,
  merchantName,
  showMerchantName = false,
  isSuccess,
  error
}) {
  const { t } = useTranslation();
  console.log(merchantName);

  return (
    <Dialog
      open={open}
      onClose={(e) => e.preventDefault()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">{t(title)}</DialogTitle>
      <Divider />
      <DialogContent>
        {showMerchantName && merchantName && (
          <Typography
            variant="body2"
            mb={2}
            sx={{
              p: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <PersonIcon fontSize="small" color="primary" />

            <strong>{t("Manager Name")}:</strong>

            <span style={{ fontWeight: 500 }}>{merchantName}</span>
          </Typography>
        )}
        <MapitPasswordTextField
          size="small"
          placeholder={t("Password")}
          type="password"
          onChange={(e) => onPasswordChange(e.target.value)}
        />
      </DialogContent>
      {(isSuccess || !!error) && (
        <DialogContent>
          {isSuccess && (
            <Typography color="green.main">{t("Done successfully")}</Typography>
          )}
          {!!error && <Typography color="error">{t(error)}</Typography>}
        </DialogContent>
      )}
      <Divider />
      <DialogActions>
        <Button
          sx={{ textTransform: "none" }}
          variant="contained"
          onClick={onClose}
        >
          {t("Close")}
        </Button>

        <LoadingButton
          sx={{ textTransform: "none", mx: "4px" }}
          variant="contained"
          onClick={onConfirm}
          loading={loading}
          autoFocus
        >
          {t("Confirm")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
